import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('/setting/personal/jobs/', 'Job title');

tbl.add(new Xtc('title', 'Title'))
tbl.add(new Xtc('initial', 'Intials'))
tbl.add(new Xtc('action', 'Actions').noSort().renderSlot('actions'))

export default tbl;

